import { useState } from "react";
import { useSelector } from "react-redux";
import { generateImage } from "../utils/generateImage";

import { ShareImagePopup } from "./ShareImagePopup";

import downloadIcon from "../assets/icons/download.png";
import facebookIcon from "../assets/icons/facebook.png";
import twitterIcon from "../assets/icons/twitter.png";
import emailIcon from "../assets/icons/email.png";

import { isIOS } from "../utils/browserDetection";

import scss from "./ShareButtons.module.scss";

export const ShareButtons = () => {
  const { score, squadSubmission } = useSelector((state: any) => state);
  const { bigWin, epicFail, rankings, totalPoints } = score;
  const [shareImage, setShareImage] = useState("");
  const shareText = `I’m ranked ${rankings.city.rank} in my city and ${rankings.global.rank} overall in %23TheImaxSuicideSquadFantasyDraft Sweepstakes!%0ACan you beat my score?`;
  const shareURL = `https://squad.imax.com/share/${squadSubmission.entryId}`;

  const handleGenerateImage = async () => {
    const dataURL = await generateImage(
      bigWin,
      epicFail,
      rankings,
      totalPoints
    );
    if (isIOS()) {
      setShareImage(dataURL);
    } else {
      const link = document.createElement("a");
      link.href = dataURL;
      link.download = "Download";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  return (
    <>
      <div className={scss.shareButtons}>
        <span>SHARE:</span>
        <button onClick={handleGenerateImage}>
          <img src={downloadIcon} alt="download" className={scss.download} />
        </button>
        <a
          href={`https://www.facebook.com/sharer/sharer.php?u=${shareURL}&quote=${shareText}`}
          target="_blank"
          rel="noreferrer"
        >
          <img src={facebookIcon} alt="facebook" className={scss.facebook} />
        </a>
        <a
          href={`https://twitter.com/intent/tweet?url=${shareURL}&text=${shareText}`}
          target="_blank"
          rel="noreferrer"
        >
          <img src={twitterIcon} alt="twitter" className={scss.twitter} />
        </a>
        <a
          href={`mailto:?subject=Check%20out%20my%20score!&body=${shareText}%0A${shareURL}`}
          target="_blank"
          rel="noreferrer"
        >
          <img src={emailIcon} alt="email" className={scss.email} />
        </a>
      </div>
      {shareImage && (
        <ShareImagePopup
          shareImage={shareImage}
          setShareImage={setShareImage}
        />
      )}
    </>
  );
};
